export default __webpack_public_path__ + "static/media/screen20.c248a68f.svg";